<template>
  <div class="container">
    <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/' }">欧蒙研究院</el-breadcrumb-item>
      <el-breadcrumb-item>个人中心</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="simple-info">
      <div class="left">
        <img class="head-img" :src="userInfo.photo ? Files+userInfo.photo : userInfo.defaultHeadImg">
        <div class="name">{{ userInfo.username }}</div>
      </div>
      <div class="right">
        <div class="score">
          <span class="num">{{ userInfo.points }}</span>
          <span>积分</span>
        </div>
        <div v-if="userInfo.isSign!==1" class="sign sign-in" @click="userInfo.isSign==1?null:userSign()">
          签到+{{ signIn[userInfo.isSign] || chushihuashijian }}积分
        </div>
        <div v-else class="sign signed">
          已签到
        </div>
        <!-- <div :class="userInfo.isSign==1?'sign signed':'sign sign-in'" @click="userInfo.isSign==1?null:userSign()">签到+{{ signIn[userInfo.isSign] || chushihuashijian }}积分</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { userSign, getPointRuleList, getPointRuleList2 } from '@/api/user'
import { Files } from '@/common/config'
import { Message } from 'element-ui'

export default {
  data() {
    return {
      signIn: {
        '7': 20,
        '20': 50,
        '30': 100
      },
      Files,
      chushihuashijian:''
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    // this.handleGetRule()
  },
  methods: {
    // handleGetRule() {
    //   const options = { formData: {}, pageData: { currentPage: 1, pageSize: 9999 } }
    //   getPointRuleList(options).then(res => {})
    // },
    userSign() {
      userSign().then(response => {
        Message({
          message: `签到成功，获得${response.data}积分`,
          type: 'success',
          duration: 3000
        })
        this.$store.dispatch('user/getInfo', this.loginForm)
      })
    }
  },
  created() {
    getPointRuleList2({type: 1}).then(res => {
      this.chushihuashijian = res.data.num
    })
  },
}
</script>
<style lang="scss" scoped>
.container{
  .simple-info{
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    padding: 1.07rem 1.25rem;
    .left{
      display: flex;
      align-items: center;
      .head-img{
        width: 3.13rem;
        height: 3.13rem;
        border-radius: 50%;
        overflow: hidden;
      }
      .name{
        font-size: 1.25rem;
        margin-left: 1.25rem;
        color: #07A903;
      }
    }
    .right{
      display: flex;
      align-items: center;
      .score{
        font-size: 0.88rem;
        margin-right: 1.88rem;
        .num{
          font-size: 1.38rem;
          color: #07A905;
        }
      }
      .sign{
        border-radius: 1.25rem;
        height: 1.88rem;
        padding: 0 0.63rem;
        font-size: 0.88rem;
        display: flex;
        align-items: center;
      }
      .sign-in{
        border: 1px solid #07A905;
        color: #07A905;
        cursor: pointer;
      }
      .signed{
        border: 1px solid #707070;
        color: #000000;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserCenterHeader.vue